(() => {
  const RUNTIME_KEY = 'KalaleRecentlyViewedRuntime';
  const STORAGE_KEY = 'kalale_recently_viewed_products';
  const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;

  const readHandles = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter((handle) => typeof handle === 'string' && HANDLE_PATTERN.test(handle));
    } catch (_error) {
      return [];
    }
  };

  const writeHandles = (handles) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (_error) {
      // Browsing can continue when storage is unavailable or full.
    }
  };

  const fetchProductCard = async (handle, sectionId) => {
    const root = window.Shopify?.routes?.root || '/';
    const productUrl = `${root}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`;
    const response = await fetch(productUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) return null;

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    return documentFragment.querySelector('[data-recent-product-card] .product-card');
  };

  const initSection = async (section) => {
    if (!(section instanceof HTMLElement) || section.dataset.recentlyViewedInitialized === 'true') return;
    section.dataset.recentlyViewedInitialized = 'true';

    const currentHandle = section.dataset.currentProductHandle || '';
    const sectionId = section.dataset.sectionId || '';
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const requestedLimit = Number.parseInt(section.dataset.productsToShow || '4', 10);
    const limit = Number.isInteger(requestedLimit) ? Math.min(Math.max(requestedLimit, 2), 8) : 4;
    if (!HANDLE_PATTERN.test(currentHandle) || !sectionId || !(grid instanceof HTMLElement)) return;

    const storedHandles = readHandles();
    const previousHandles = storedHandles.filter((handle) => handle !== currentHandle).slice(0, limit);
    writeHandles([currentHandle, ...previousHandles, ...storedHandles.filter((handle) => handle !== currentHandle && !previousHandles.includes(handle))].slice(0, 12));

    if (previousHandles.length === 0) return;

    const results = await Promise.allSettled(
      previousHandles.map((handle) => fetchProductCard(handle, sectionId))
    );
    if (!section.isConnected) return;

    const cards = results
      .filter((result) => result.status === 'fulfilled' && result.value instanceof HTMLElement)
      .map((result) => result.value);
    if (cards.length === 0) return;

    grid.replaceChildren(...cards);
    section.hidden = false;
  };

  const initWithin = (root) => {
    if (root instanceof HTMLElement && root.matches('[data-recently-viewed-section]')) {
      void initSection(root);
    }
    root.querySelectorAll?.('[data-recently-viewed-section]').forEach((section) => {
      void initSection(section);
    });
  };

  if (window[RUNTIME_KEY]) {
    window[RUNTIME_KEY].initWithin(document);
    return;
  }

  window[RUNTIME_KEY] = { initWithin };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
